module.exports = __webpack_public_path__ + "img/csm_expovina_01_web_9047677c1a.aad21b85.jpg";